/**
 * QuietPhoneMark — OPEN-210 (Corbin 2026-11-01). A small warning beside a driver's
 * availability dot: on shift, but the phone has not reached the server in over 30 minutes.
 */

import * as React from 'react';
import { AlertTriangle } from 'lucide-react';

const QUIET_PHONE_LABEL = 'Phone quiet: no contact for over 30 minutes';

export function QuietPhoneMark(): React.JSX.Element {
  return (
    <span
      data-testid="quiet-phone-mark"
      role="img"
      aria-label={QUIET_PHONE_LABEL}
      title={QUIET_PHONE_LABEL}
      style={{ display: 'inline-flex', flexShrink: 0, color: 'var(--color-warning)' }}
    >
      <AlertTriangle size={12} aria-hidden="true" />
    </span>
  );
}
